import { render, staticRenderFns } from "./ModalAvaliacao.vue?vue&type=template&id=3cf78cfa&scoped=true"
import script from "./ModalAvaliacao.vue?vue&type=script&lang=js"
export * from "./ModalAvaliacao.vue?vue&type=script&lang=js"
import style0 from "./ModalAvaliacao.vue?vue&type=style&index=0&id=3cf78cfa&prod&scoped=true&lang=css"
import style1 from "./ModalAvaliacao.vue?vue&type=style&index=1&id=3cf78cfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf78cfa",
  null
  
)

export default component.exports